import { IndustryDescription, IndustryProductID, OptionAvailability } from './../../model/industry';
import { Customer } from './../../model/customer';
import { environment } from './../../../environments/environment';
import { formatDate, registerLocaleData } from '@angular/common';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IndustryPurchasedInfo } from 'src/app/model/industry';
import { ConfigurationService } from './configuration.service';
import localeIt from '@angular/common/locales/it';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Feature, OptionInfo, OrderPreviewRows } from 'src/app/model/feature';
import { ItemsAdministrativeInfo } from 'src/app/model/configuration';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
    providedIn: 'root',
})
export class PdfCreatorService {
    //pdf string
    totalAmount = '';
    totalMluAmount = '';
    private loadedImages: any;
    private magoLogo = '';
    private microareazg = '';
    private isMagoWeb = false;
    constructor(
        private configurationService: ConfigurationService,
        private http: HttpClient,
        private backend: HttpBackend,
        private variable: TranslatedVariables
    ) {}

    private async createQuotationPDF(
        userlanguage: string,
        selectedEditionDescription: string,
        calfullNr: number,
        currIndustryPurchInfo: IndustryPurchasedInfo,
        currentIndustry: IndustryDescription,
        selectedCountry: string,
        aLaCarte: boolean,
        isSaaS: boolean
    ) {
        registerLocaleData(localeIt, 'it-IT');
        this.isMagoWeb = currIndustryPurchInfo.productID == IndustryProductID.MW;
        this.loadedImages = await this.getImages();
        let dateTimeToday = formatDate(new Date(), 'longDate', userlanguage);
        let previewRows: OrderPreviewRows[] = [];
        let editionCode = currIndustryPurchInfo.Edition.EditionCode.toLowerCase();
        let correctQty = !this.isMagoWeb ? calfullNr : 1;
        let refItemsAdministrativeInfo: ItemsAdministrativeInfo = null;
        if (!aLaCarte) {
            //aggiungo la riga dell'edition
            if (isSaaS) {
                refItemsAdministrativeInfo = currentIndustry.SASPriceRanges.find(
                    (x) => x.ModuleCode == currentIndustry.ModuleCode && x.EditionCode == editionCode
                );
                let f: OrderPreviewRows = new OrderPreviewRows();
                f.itemDescription = currIndustryPurchInfo.TranslatedName.concat(' ' + selectedEditionDescription);
                f.itemCode = this.getFeatureItemCode(refItemsAdministrativeInfo);
                f.qty = correctQty;
                f.price = refItemsAdministrativeInfo.Price != null ? refItemsAdministrativeInfo.Price : 0;
                f.totalPrice = !this.isMagoWeb ? f.price * f.qty : f.price;
                previewRows.push(f);
            } else {
                let f: OrderPreviewRows = new OrderPreviewRows();
                refItemsAdministrativeInfo = this.configurationService.getIndustrySelectedRange(currIndustryPurchInfo);
                f.itemDescription = currIndustryPurchInfo.TranslatedName.concat(' ' + selectedEditionDescription);
                f.itemCode = this.getFeatureItemCode(refItemsAdministrativeInfo);
                f.qty = correctQty;

                f.price = refItemsAdministrativeInfo != null ? refItemsAdministrativeInfo.Price : 0;
                f.totalPrice = !this.isMagoWeb ? f.price * f.qty : f.price;
                //riga dell'edition
                previewRows.push(f);
            }
        } else {
            //aggiungo la riga del server
            refItemsAdministrativeInfo = currentIndustry.PriceRanges.find(
                (x) => (x.ModuleCode == 'SEVR' || x.ModuleCode == 'SERD') && x.EditionCode == editionCode
            );
            this.addFeature(
                refItemsAdministrativeInfo,
                currIndustryPurchInfo.SelectedFeatures,
                currIndustryPurchInfo.OptionalFeaturesOptionInfo,
                editionCode,
                previewRows,
                correctQty
            );
        }
        this.addOtherFeature(
            currentIndustry.PriceRanges,
            currIndustryPurchInfo.OptionalFeatures,
            currIndustryPurchInfo.OptionalFeaturesOptionInfo,
            editionCode,
            previewRows,
            correctQty
        );

        this.addOtherFeature(
            currentIndustry.PriceRanges,
            currIndustryPurchInfo.CountableFeatures,
            currIndustryPurchInfo.OptionalFeaturesOptionInfo,
            editionCode,
            previewRows,
            0
        );
        //aggiungo i ppt
        currIndustryPurchInfo.PptFeatures.forEach((row) => {
            let isPPT = row.Options.find(
                (x) => x.edition.toLowerCase() == editionCode && x.availability.toLowerCase() == OptionAvailability.PPT
            );
            if (isPPT) {
                let f: OrderPreviewRows = new OrderPreviewRows();
                f.itemDescription = row.Description;
                f.itemCode = this.getFeatureItemCode(refItemsAdministrativeInfo);
                f.qty = 1;
                f.price = 0;
                previewRows.push(f);
            }
        });
        //}

        let total = this.getTotalAmount(previewRows);
        this.totalMluAmount = currIndustryPurchInfo.totalMLUAmount.toFixed(2) + ' €';
        this.totalAmount = aLaCarte ? Math.round(total).toFixed(2) + ' €' : total.toFixed(2) + ' €';
        var stringTotal =
            currIndustryPurchInfo.productID === IndustryProductID.MC ? this.variable.totalCostMonthUsertxt : this.variable.totalCost;
        var docDefinition = {
            content: [
                {
                    table: {
                        widths: ['*', 'auto'],
                        body: [
                            [
                                { image: 'logo', width: 100, style: 'headerLeftLogo' },
                                { image: 'microareazg', width: 100, style: 'microareazgLogo' },
                            ],
                        ],
                    },
                    layout: 'noBorders',
                },
                { stack: [{ text: 'Data:' + dateTimeToday, style: 'dataStyle', margin: [0, 50, 0, 0] }] },
                {
                    stack: [{ text: this.variable.configurationSummary, style: 'titleStyle', margin: [0, 50, 0, 25] }],
                },

                {
                    text: [
                        { text: this.variable.industry, style: 'subTitleBoldStyle' },
                        { text: ':  ', style: 'subTitleBoldStyle' },
                        { text: currIndustryPurchInfo.TranslatedName, style: 'subTitleStyle' },
                    ],
                },
                {
                    text: [
                        { text: this.variable.edition, style: 'subTitleBoldStyle' },
                        { text: '  ' },
                        { text: selectedEditionDescription, style: 'subTitleStyle' },
                    ],
                },
                {
                    text: [
                        { text: this.variable.country, style: 'subTitleBoldStyle' },
                        { text: '  ' },
                        { text: selectedCountry, style: 'subTitleStyle' },
                    ],
                    margin: [0, 0, 0, 25],
                },
                aLaCarte
                    ? this.tableSelectedFeatureAlaCarte(previewRows, [
                          { text: this.variable.itemtxt, style: 'tableHeader', fillColor: '#eeeeee' },
                          { text: this.variable.userstxt, style: 'tableHeader', fillColor: '#eeeeee' },
                      ])
                    : this.tableSelectedFeature(previewRows, [
                          { text: this.variable.itemtxt, style: 'tableHeader', fillColor: '#eeeeee' },
                          { text: this.variable.userstxt, style: 'tableHeader', fillColor: '#eeeeee' },
                          { text: this.variable.unitPrice, style: 'tableHeader', alignment: 'right', fillColor: '#eeeeee' },
                          { text: this.variable.totalpricetxt, style: 'tableHeader', alignment: 'right', fillColor: '#eeeeee' },
                      ]),

                {
                    style: 'tableExample',
                    table: {
                        widths: ['auto', '*'],
                        body: [
                            [
                                { text: stringTotal, style: 'total' },
                                { text: this.totalAmount, style: 'total', bold: true, alignment: 'right' },
                            ],
                            this.isMagoWeb
                                ? [
                                      { text: this.variable.totalMLUAmount, style: 'total' },
                                      { text: this.totalMluAmount, style: 'total', bold: true, alignment: 'right' },
                                  ]
                                : [{ text: '' }, { text: '' }],
                        ],
                    },
                    layout: 'noBorders',
                },
                {
                    text: [{ text: this.variable.commonsVATExcluded, style: 'footerStyle' }],
                    margin: [0, 10, 0, 0],
                },
                {
                    text: [{ text: this.variable.pricesDisclaimer, style: 'footerStyle' }],
                    margin: [0, 10, 0, 0],
                },
                {
                    text: [{ text: this.variable.thanksforvisitingus, style: 'footerBoldStyle', alignment: 'center' }],
                    margin: [0, 10, 0, 0],
                },
            ],
            images: this.loadedImages,

            styles: {
                dataStyle: {
                    fontSize: 10,
                    bold: false,
                    color: 'rgba(0, 0, 0, 0.87)',
                },
                itemCodeStyle: {
                    fontSize: 11,
                    bold: false,
                    color: 'rgba(0, 0, 0, 0.87)',
                },
                titleStyle: {
                    fontSize: 18,
                    bold: false,
                    color: 'rgba(0, 0, 0, 0.87)',
                },
                subTitleStyle: {
                    fontSize: 12,
                    bold: false,
                    color: 'rgba(0, 0, 0, 0.87)',
                },
                subTitleBoldStyle: {
                    fontSize: 12,
                    bold: true,
                    color: 'rgba(0, 0, 0, 0.87)',
                },
                total: {
                    fontSize: 12,
                    bold: true,
                    color: 'rgba(0, 0, 0, 0.87)',
                },
                tableExample: {
                    fontSize: 10,
                    color: 'rgba(0, 0, 0, 0.87)',
                    margin: [0, 15, 0, 15],
                },
                headerLeftLogo: {
                    alignment: 'Left',
                    margin: [0, 20, 0, 20],
                },
                microareazgLogo: {
                    alignment: 'right',
                    margin: [0, 20, 0, 20],
                },
                tableHeader: {
                    bold: true,
                    fontSize: 12,
                    color: '#666666',
                },
                footerStyle: {
                    fontSize: 10,
                    color: 'rgba(0, 0, 0, 0.87)',
                },
                footerBoldStyle: {
                    bold: true,
                    fontSize: 12,
                    color: 'rgba(0, 0, 0, 0.87)',
                },
            },
        };

        return docDefinition;
    }
    private getFeatureItemCode(info: ItemsAdministrativeInfo) {
        if (info == undefined || info.ItemCode.length == 0) {
            return '-';
        }
        return info.ItemCode;
    }
    public async createPdf(
        userlanguage: string,
        selectedEditionDescription: string,
        calfullNr: number,
        currIndustryPurchInfo: IndustryPurchasedInfo,
        currentIndustry: IndustryDescription,
        selectedCountry: string,
        aLaCarte: boolean,
        isSaaS: boolean
    ) {
        let docDefinition = await this.createQuotationPDF(
            userlanguage,
            selectedEditionDescription,
            calfullNr,
            currIndustryPurchInfo,
            currentIndustry,
            selectedCountry,
            aLaCarte,
            isSaaS
        );

        const pdfDocGenerator = pdfMake.createPdf(docDefinition).open();
        return pdfDocGenerator;
    }
    public openPdf(pdfDocGenerator: any) {
        pdfDocGenerator?.open({ defaultFileName: 'preventivo.pdf' });
    }

    private addFeature(
        refItemsAdministrativeInfo: ItemsAdministrativeInfo,
        data: Feature[],
        featureInfo: OptionInfo[],
        edition: string,
        rows: OrderPreviewRows[],
        calfullNr: number
    ) {
        if (featureInfo.length == 0) return;

        for (let i = 0; i < data.length; i++) {
            let row = data[i];
            let alwaysFeature = row.Options.find(
                (x) => x.edition.toLowerCase() == edition && x.availability.toLowerCase() == OptionAvailability.ALWAYS
            );
            if (this.isMagoWeb && alwaysFeature) continue;
            let isPPT = row.Options.find(
                (x) => x.edition.toLowerCase() == edition && x.availability.toLowerCase() == OptionAvailability.PPT
            );
            if (!isPPT) {
                let optInfo = featureInfo.find(
                    (x) => x.optionID == row.OptionID && x.selectedEdition.toLowerCase() == edition.toLowerCase()
                );
                if (!optInfo) return;
                let r: OrderPreviewRows = new OrderPreviewRows();
                r.itemDescription = row.Description.toString();
                r.itemCode = this.getFeatureItemCode(refItemsAdministrativeInfo);
                r.qty = calfullNr > 0 ? calfullNr : optInfo.nrOfUser;
                r.price = optInfo.price;
                r.totalPrice = r.qty * r.price;
                rows.push(r);
            }
        }
    }
    private addOtherFeature(
        refItemsAdministrativeInfo: ItemsAdministrativeInfo[],
        data: Feature[],
        featureInfo: OptionInfo[],
        edition: string,
        rows: OrderPreviewRows[],
        calfullNr: number
    ) {
        if (featureInfo.length == 0) return;

        for (let i = 0; i < data.length; i++) {
            let row = data[i];
            let alwaysFeature = row.Options.find(
                (x) => x.edition.toLowerCase() == edition && x.availability.toLowerCase() == OptionAvailability.ALWAYS
            );
            if (this.isMagoWeb && alwaysFeature) continue;
            let isPPT = row.Options.find(
                (x) => x.edition.toLowerCase() == edition && x.availability.toLowerCase() == OptionAvailability.PPT
            );
            if (!isPPT) {
                let optInfo = featureInfo.find(
                    (x) => x.optionID == row.OptionID && x.selectedEdition.toLowerCase() == edition.toLowerCase()
                );
                if (!optInfo) return;
                let administrativeInfo: ItemsAdministrativeInfo = refItemsAdministrativeInfo.find(
                    (x) => x.ModuleCode == row.OptionID && x.EditionCode == edition
                );
                let r: OrderPreviewRows = new OrderPreviewRows();
                r.itemDescription = row.Description.toString();
                r.itemCode = this.getFeatureItemCode(administrativeInfo);
                r.qty = calfullNr > 0 ? calfullNr : optInfo.nrOfUser;
                r.price = optInfo.price;
                r.totalPrice = r.qty * r.price;
                rows.push(r);
            }
        }
    }

    private tableSelectedFeatureAlaCarte(data, columns) {
        let t =
            data.length > 0
                ? {
                      table: {
                          headerRows: 1,
                          widths: ['*', 100],
                          body: this.buildTableBodyAlacarte(data, columns),
                      },
                  }
                : '';
        return t;
    }
    private tableSelectedFeature(data, columns) {
        let t =
            data.length > 0
                ? {
                      table: {
                          headerRows: 1,
                          widths: ['*', 100, 100, 100],
                          body: this.buildTableBody(data, columns),
                      },
                  }
                : '';
        return t;
    }

    private async getImages() {
        this.microareazg = await this.getBase64('./assets/Zuc_Orizz_B_Small.png');
        this.magoLogo = this.isMagoWeb ? await this.getBase64('./assets/MW_b.png') : await this.getBase64('./assets/MAGOCLOUD-logo.png');
        let img = {
            logo: this.magoLogo,
            microareazg: this.microareazg,
        };

        return img;
    }

    private buildTableBody(data: OrderPreviewRows[], columns) {
        var body = [];

        body.push(columns);
        let i = 0;

        data.forEach(function (row) {
            var dataRow = [];
            let rowPriceTxt = row.price == 0 ? '-' : row.price.toFixed(2);
            let totalPrice = row.qty * row.price;
            let totalPriceTxt = totalPrice == 0 ? '-' : totalPrice.toFixed(2);
            if (i < data.length - 1) {
                dataRow.push({
                    text: [
                        { text: row.itemDescription.toString() },
                        { text: ' (' + row.itemCode.toString() + ')', style: 'itemCodeStyle' },
                    ],
                    border: [true, false, true, false],
                });
                dataRow.push({ text: row.qty.toString(), border: [true, false, true, false] });
                dataRow.push({ text: rowPriceTxt + ' €', alignment: 'right', border: [true, false, true, false] });
                dataRow.push({
                    text: totalPriceTxt + ' €',
                    alignment: 'right',
                    border: [true, false, true, false],
                });
            } else {
                dataRow.push({
                    text: [
                        { text: row.itemDescription.toString() },
                        { text: ' (' + row.itemCode.toString() + ')', style: 'itemCodeStyle' },
                    ],
                    border: [true, false, true, true],
                });
                dataRow.push({ text: row.qty.toString(), border: [true, false, true, true] });
                dataRow.push({ text: rowPriceTxt + ' €', alignment: 'right', border: [true, false, true, true] });
                dataRow.push({ text: totalPriceTxt + ' €', alignment: 'right', border: [true, false, true, true] });
            }
            body.push(dataRow);
            i++;
        });

        return body;
    }
    private buildTableBodyAlacarte(data: OrderPreviewRows[], columns) {
        var body = [];

        body.push(columns);
        let i = 0;

        data.forEach(function (row) {
            var dataRow = [];
            if (i < data.length - 1) {
                dataRow.push({
                    text: [
                        { text: row.itemDescription.toString() },
                        { text: ' (' + row.itemCode.toString() + ')', style: 'itemCodeStyle' },
                    ],
                    border: [true, false, true, false],
                });
                dataRow.push({ text: row.qty.toString(), border: [true, false, true, false] });
            } else {
                dataRow.push({
                    text: [
                        { text: row.itemDescription.toString() },
                        { text: ' (' + row.itemCode.toString() + ')', style: 'itemCodeStyle' },
                    ],
                    border: [true, false, true, true],
                });
                dataRow.push({ text: row.qty.toString(), border: [true, false, true, true] });
            }
            body.push(dataRow);
            i++;
        });

        return body;
    }
    private getTotalAmount(data: OrderPreviewRows[]) {
        let total: number = 0;
        let i = 0;
        data.forEach(function (row) {
            let totalPrice = row.qty * row.price;
            total += totalPrice;
            i++;
        });
        return total;
    }

    private async GetStringFromBlob(blob: any): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event: any) => {
                resolve(event.target.result);
            };
            reader.onerror = (event: any) => {
                reject('NO');
            };
            const binaryString = reader.readAsDataURL(blob);
        });
    }
    private async getBase64(url: string) {
        let blob = await this.http.get(url, { responseType: 'blob' }).toPromise();
        return await this.GetStringFromBlob(blob);
    }
}
